import { ConnectProto } from "@racoon/api";
import { type KeysOf, Namespace } from "@racoon/i18n";
import {
  IcGarrage,
  IcLocationDepot,
  IcLocationDisposalSite,
  IcLocationProcessingPlant,
  IcLocationSortingComplex,
  IcLocationTransferStation,
} from "@racoon/icons";

type LocationTypeStyle = {
  Icon: typeof IcLocationDepot;
  /** Of the type label in the hover card (Figma «Location Hover Tooltip»). */
  color: string;
  labelKey?: KeysOf<Namespace.GpsTracking>;
};

const { LocationType } = ConnectProto;

const STYLES: Partial<Record<ConnectProto.LocationType, LocationTypeStyle>> = {
  [LocationType.DISPOSAL_SITE]: {
    Icon: IcLocationDisposalSite,
    color: "#EA580C",
    labelKey: "mapLocationDisposalSite",
  },
  [LocationType.DEPOT]: { Icon: IcLocationDepot, color: "#EF4444", labelKey: "mapLocationDepot" },
  [LocationType.PROCESSING_PLANT]: {
    Icon: IcLocationProcessingPlant,
    color: "#16A34A",
    labelKey: "mapLocationProcessingPlant",
  },
  [LocationType.SORTING_COMPLEX]: {
    Icon: IcLocationSortingComplex,
    color: "#93C5FD",
    labelKey: "mapLocationSortingComplex",
  },
  [LocationType.TRANSFER_STATION]: {
    Icon: IcLocationTransferStation,
    color: "#8E51FF",
    labelKey: "mapLocationTransferStation",
  },
};

// Unknown (another organization's location) and types Figma has no icon for.
const FALLBACK: LocationTypeStyle = { Icon: IcGarrage, color: "#EF4444" };

export const locationTypeStyle = (type?: ConnectProto.LocationType): LocationTypeStyle =>
  (type != null && STYLES[type]) || FALLBACK;
